import { useEffect, useRef, useState } from "react";
import { Button, Col, Input, Row, Space, Table } from "antd";
import WeekSelectBitacora from "../../Forms/Dates/WeekSelectBitacora";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import Tag from "../../../utils/StatusTag";
import createAxiosInstanceNew from "../../../Api/AxiosInstance/AxiosInstance";
import { Card } from "../../Card/Card";

export default function BitacoraFaltantesTable() {
  const [faltantes, setFaltantes] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const getMissings = async () => {
    const axiosInstance = await createAxiosInstanceNew();

    const res = await axiosInstance.get(`faltante/bitacora`, {
      params: {
        FIPAISID: 1,
        FIMARCAID: 6,
      },
    });

    if (res.status === 200) {
      setFaltantes(res.data.body);
    }
  };

  useEffect(() => {
    getMissings();
  }, []);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          {/*           <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpiar
          </Button>*/}
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Código faltante",
      dataIndex: "codigoFaltante",
      key: "codigoFaltante",
      ...getColumnSearchProps("codigoFaltante"),
    },
    {
      title: "Fecha de modificación",
      dataIndex: "fechaModificacion",
      key: "fechaModificacion",
      sorter: (a, b) => new Date(a.fechaModificacion) - new Date(b.fechaModificacion),
    },
    {
      title: "Estatus",
      dataIndex: "estatus",
      key: "estatus",
      render: (item) => <Tag item={item} />,
      filters: [
        { text: "Aclarado", value: "Aclarado" },
        { text: "Incobrables", value: "Incobrable" },
        { text: "Seguimiento CxC", value: "Seguimiento CxC" },
        { text: "Cancelado", value: "Cancelado" },
      ],
      onFilter: (value, record) => record.estatus === value,
    },
    {
      title: "Usuario",
      dataIndex: "usuario",
      key: "usuario",
      ...getColumnSearchProps("usuario"),
    },
    {
      title: "Seguimiento analista",
      dataIndex: "seguimientoAnalista",
      key: "seguimientoAnalista",
    },
  ];

  return (
    <section className="main-content">
      <Card className="bg-white card-container py">
        <h3 className="card-title">Reporte Faltantes</h3>

        <WeekSelectBitacora setFaltantes={setFaltantes} />
      </Card>

      {/* table */}
      <Card className="bg-white">
        <div className="table-container">
          <Table dataSource={faltantes} rowKey={null} columns={columns} />
        </div>
      </Card>
    </section>
  );
}
